import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import classes from '@nerdwallet/base-styles/classes';

const Spacer = ({ ndsMarginClass }) => {
  const spacerPrefix = `margin-bottom-${ndsMarginClass}`;

  return (
    <div className={classNames(['spacer-div', classes(`${spacerPrefix}`)])}>
      &nbsp;
    </div>
  );
};

Spacer.displayName = 'Spacer';

Spacer.propTypes = {
  ndsMarginClass: PropTypes.string,
};

Spacer.defaultProps = {
  ndsMarginClass: '2',
};

export default Spacer;
